<template>
    <div class="q-pa-md" >
        <div class="position-absolute" style="right: 15px;top:75px; z-index: 1">
            <div class="d-flex">
                <q-input class="searchBox" debounce="300" placeholder="Search" style="width: 350px"
                         v-model="filter">
                    <template v-slot:prepend>
                        <q-icon name="search"/>
                    </template>
                </q-input>

            </div>
        </div>
        <q-tabs class="text-primary" align="left" style="padding-left: 16px;padding-right: 16px" v-model="tab">
            <q-tab :label="tab.label+' ('+tab.count+')'" :name="tab.component" :key="index"
                   class="text-blue" v-for="(tab, index) in tabArr"></q-tab>

        </q-tabs>
        <q-separator></q-separator>
        <paid-inventory-purchase-online :filter="filter" @ordersCount="tabArr[0].count=$event" ref="PaidInventoryPurchaseOnline"
                       v-show="tab==='PaidInventoryPurchaseOnline'"></paid-inventory-purchase-online>
        <failed-inventory-purchase-online :filter="filter" @ordersCount="tabArr[1].count=$event" ref="FailedInventoryPurchaseOnline"
        v-show="tab==='FailedInventoryPurchaseOnline'"></failed-inventory-purchase-online>
        <invoice-sent-purchase-online :filter="filter" @ordersCount="tabArr[2].count=$event" ref="InvoiceSentPurchaseOnline"
        v-show="tab==='InvoiceSentPurchaseOnline'"></invoice-sent-purchase-online>
    </div>
</template>

<script>

   
    import PaidInventoryPurchaseOnline from '../ManageStock/PaidInventoryPurchaseOnline'
    import FailedInventoryPurchaseOnline from '../ManageStock/FailedInventoryPurchaseOnline'
    import InvoiceSentPurchaseOnline from '../ManageStock/InvoiceSentPurchaseOnline'
    import axios from 'axios'; 
    import Constants from '../../Constants/Constant';

    export default {
        name: 'PurchaseOnline',
        components: {
            PaidInventoryPurchaseOnline,
            FailedInventoryPurchaseOnline,
            InvoiceSentPurchaseOnline
                    },
        data: function () {
            return {
                userObj: JSON.parse(localStorage.getItem('user')),
                tab: 'PaidInventoryPurchaseOnline',
                filter: '',
                tabArr: [
                    { label: 'Paid', component: 'PaidInventoryPurchaseOnline', count: 0 },
                    { label: 'Failed', component: 'FailedInventoryPurchaseOnline', count: 0 },
                    { label: 'Invoice Sent', component: 'InvoiceSentPurchaseOnline', count: 0 }
                ],
            }
        },
        methods:{
            async fetchData() {
      try {
        const apiUrl =  Constants.graphql_backend_url + 'rest/order/my/count'
        const paidCount = await axios.post(apiUrl, {
            orgId: this.userObj.orgId,
            status: {"_eq": "success"},
            isInvoiceSent: {"_eq": false}
        });
        const failedCount = await axios.post(apiUrl, {
            orgId: this.userObj.orgId,
            status: {"_neq": "success"},
            isInvoiceSent: {}
        });
        const invoiceSentCount = await axios.post(apiUrl, {
            orgId: this.userObj.orgId,
            status: {"_eq": "success"},
            isInvoiceSent: {"_eq": true}
        });
        this.tabArr[0].count = paidCount.data.OnlineOrders_aggregate.aggregate.count;
        this.tabArr[1].count = failedCount.data.OnlineOrders_aggregate.aggregate.count;
        this.tabArr[2].count = invoiceSentCount.data.OnlineOrders_aggregate.aggregate.count;
      } catch (error) {
        console.error('API Error:', error);
      }
    },
        },
        mounted() {
            this.fetchData();
        },
    }
</script>

<style scoped>

</style>